import { render, staticRenderFns } from "./TrainMultiCopy.vue?vue&type=template&id=3ba116e8"
import script from "./trainMultiCopy.ts?vue&type=script&lang=js&external"
export * from "./trainMultiCopy.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports